import { render, staticRenderFns } from "./TransferSelect.vue?vue&type=template&id=00228ea7&scoped=true"
import script from "./TransferSelect.vue?vue&type=script&lang=js"
export * from "./TransferSelect.vue?vue&type=script&lang=js"
import style0 from "./TransferSelect.vue?vue&type=style&index=0&id=00228ea7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00228ea7",
  null
  
)

export default component.exports